import { TemplateElement, defineElement, html } from '@webtides/element-js';

/**
 * E-Banking slider item component - a simple wrapper for slide content.
 * Used as a direct child of mb-e-banking-slider-group.
 */
export default class EBankingSliderItem extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {};
    }

    template() {
        return html`
            <div class="h-full">
                <slot></slot>
            </div>
        `;
    }
}

defineElement('mb-e-banking-slider-item', EBankingSliderItem);
